module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-chrome"
  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _c('div', {
    staticClass: "page-content container"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_c('img', {
    staticClass: "margin-right-10",
    attrs: {
      "src": "/static/images/byteark-logo-blue.png",
      "title": "ByteArk",
      "height": "60"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-xs-right"
  }, [_c('h3', {
    staticClass: "m-t-20 m-b-0"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.action.usageReport")) + " " + _vm._s(this.currentMonth))]), _vm._v(" "), _c('p', {
    staticClass: "font-size-18"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.dateIssued")) + " : " + _vm._s(this.dateIssued))]), _vm._v(" "), _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.team")) + ": " + _vm._s(_vm.team ? _vm.team.name : ''))]), _vm._v(" "), (_vm.team ? _vm.team.reseller_id != 0 : false) ? _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(" Reseller : " + _vm._s(_vm.team.reseller.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "page-invoice-table table-responsive m-t-60"
  }, [_c('table', {
    staticClass: "table table-hover text-right"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("statement.labels.statement")))]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-right"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.usage")))]), _vm._v(" "), (_vm.usages.human_total_cost) ? _c('th', {
    staticClass: "text-xs-right"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.amount")))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.usages.items), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-right"
    }, [_vm._v(_vm._s(item.human_data_usage))]), _vm._v(" "), (item.human_cost) ? _c('td', {
      staticClass: "text-xs-right"
    }, [_vm._v(_vm._s(item.human_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))]) : _vm._e()])
  }))])]), _vm._v(" "), (_vm.usages.human_total_cost) ? _c('div', {
    staticClass: "text-xs-right clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "page-invoice-amount font-size-18"
  }, [_vm._v(_vm._s(_vm.$t("text.total")) + " :\n                "), _c('span', [_vm._v(_vm._s(_vm.usages.human_total_cost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]) : _vm._e(), _vm._v(" "), (_vm.usages.human_total_cost && _vm.usages.charged_balance_transaction) ? _c('div', {
    staticClass: "row m-t-35"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-8"
  }, [_c('div', {
    staticClass: "text-xs-right clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "page-invoice-amount m-b-5"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.credit")) + " (" + _vm._s(this.dateIssued) + "):\n                    "), _c('span', [_vm._v(_vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.credit + _vm.usages.charged_balance_transaction.balance : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "page-invoice-amount m-b-5"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.charge")) + ":\n                    "), _c('span', [_vm._v("-" + _vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.credit : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "page-invoice-amount font-size-18"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.remaining")) + " :\n                    "), _c('span', [_vm._v(_vm._s(_vm.usages.charged_balance_transaction ? _vm.usages.charged_balance_transaction.balance : '') + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(!_vm.isPrinting) ? _c('button', {
    staticClass: "btn btn-animate btn-animate-side btn-default btn-outline",
    attrs: {
      "type": "button",
      "onclick": "javascript:window.print(); "
    }
  }, [_c('span', [_c('i', {
    staticClass: "icon md-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("action.print")))])]) : _vm._e()])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60324df7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/pages/PageUsageReport.vue
// module id = 541
// module chunks = 1